import React, { Component } from 'react';

import paymobLogo from './../../statics/img/paymobLogo.svg';


class simpleHeader_new extends Component {
    
    render(){
        return (
            <div className="newHeader">
                 <a className="" href="https://www.paymobsolutions.com" target="_blanck" >
                    <img alt="Brand" src={paymobLogo} width="180" />
                </a>
                <p>
                    Express Checkout
                </p>
            </div>  
        );
    }

}

export default simpleHeader_new;
